import { OVERALL_ANALYSIS_SCORE_MAP } from "../config";
import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types"

export const getOverallSectionScore = (resume: ResumeAnalysis, maxOverAllScore: number ) => {

  let mistakesCount = 0;

  const totalWords = resume.overallAnalysis?.totalNumberOfWords || 0;
  const totalBulletPoints = resume.overallAnalysis?.totalNumberOfBulletPoints || 0;
  const isDateStructureConsistent = resume.overallAnalysis?.isDateStructureConsistent || false;
  const totalRepeatedSentences = resume.overallAnalysis?.repeatedSentences.count || 0;
  const totalRepeatedActionVerbs = resume.overallAnalysis?.repeatedActionVerbs.count || 0;
  const totalRepeatedPhrases = resume.overallAnalysis?.repeatedPhrases.count || 0;

  // Check if resume has any meaningful content across all sections - if completely empty, return 0
  // Don't rely solely on totalWords as it might include placeholder text
  const hasAnyContent = Boolean(
    (resume.profile?.name && String(resume.profile.name).trim()) ||
    (resume.profile?.email && String(resume.profile.email).trim()) ||
    (resume.profile?.phone && String(resume.profile.phone).trim()) ||
    (resume.profile?.summaryAnalysis?.statement && String(resume.profile.summaryAnalysis.statement).trim()) ||
    (resume.workExperiences?.individualWorkExperiencesAnalysis?.length > 0) ||
    (resume.projects?.individualProjectsAnalysis?.length > 0) ||
    (resume.educations?.individualEducationsAnalysis?.length > 0) ||
    (resume.skills?.descriptionAnalysis?.length > 0) ||
    (resume.certifications?.individualCertificatesAnalysis?.length > 0) ||
    (resume.awards?.individualAwardsAnalysis?.length > 0) ||
    (resume.languages?.individualLanguagesAnalysis?.length > 0) ||
    (resume.custom?.descriptionAnalysis?.length > 0)
  );
  
  if (!hasAnyContent) {
    return {
      overallScore: 0,
      wordScore: 0,
      bulletPointScore: 0,
      dateStructureScore: 0,
      repeatedSentencesScore: 0,
      repeatedActionVerbsScore: 0,
      repeatedPhrasesScore: 0
    };
  }

  let wordScore = OVERALL_ANALYSIS_SCORE_MAP.wordCount;
  let bulletPointScore = OVERALL_ANALYSIS_SCORE_MAP.bulletPoints;
  const dateStructureScore = isDateStructureConsistent ? OVERALL_ANALYSIS_SCORE_MAP.dateStructureConsistency : 0;
  let repeatedSentencesScore = OVERALL_ANALYSIS_SCORE_MAP.repeatedSentences;
  let repeatedActionVerbsScore = OVERALL_ANALYSIS_SCORE_MAP.repeatedActionVerbs;
  let repeatedPhrasesScore = OVERALL_ANALYSIS_SCORE_MAP.repeatedPhrases;



  // Calculate word score
  if (totalWords < 400 || totalWords > 600) {
    mistakesCount++;
  }

  // Calculate bullet point score
  if (totalBulletPoints < 12 || totalBulletPoints > 20) {
    mistakesCount++;
  }

  if (totalRepeatedActionVerbs > 0) {
    mistakesCount += totalRepeatedActionVerbs
  }

  if (totalRepeatedSentences > 0) {
    mistakesCount += totalRepeatedSentences
  }
  
  if (totalRepeatedPhrases > 0) {
    mistakesCount += totalRepeatedPhrases
  }
  if (!isDateStructureConsistent) {
    mistakesCount++;
  }

  let totalScore = maxOverAllScore
  if (mistakesCount > 0 && mistakesCount <=3) {
    totalScore -= 0.1 * maxOverAllScore;
  } else if (mistakesCount > 3 && mistakesCount <=6) {  
    totalScore -= 0.25 * maxOverAllScore;
  } else if (mistakesCount > 6 && mistakesCount <=12) {
    totalScore -= 0.4 * maxOverAllScore;
  } else if (mistakesCount > 12 && mistakesCount <=18) {
    totalScore -= 0.6 * maxOverAllScore;
  } else if (mistakesCount > 18 ){
    totalScore -= 0.8 * maxOverAllScore;
  }

  // Calculate repeated sentences score
  repeatedSentencesScore = OVERALL_ANALYSIS_SCORE_MAP.repeatedSentences - Math.min(totalRepeatedSentences / 2, OVERALL_ANALYSIS_SCORE_MAP.repeatedSentences);

  // Calculate repeated action verbs score
  repeatedActionVerbsScore = OVERALL_ANALYSIS_SCORE_MAP.repeatedActionVerbs - Math.min(totalRepeatedActionVerbs / 2, OVERALL_ANALYSIS_SCORE_MAP.repeatedActionVerbs);

  // Calculate repeated phrases score
  repeatedPhrasesScore = OVERALL_ANALYSIS_SCORE_MAP.repeatedPhrases - Math.min(totalRepeatedPhrases / 2, OVERALL_ANALYSIS_SCORE_MAP.repeatedPhrases);

  // Calculate overall score
  const overallScore = wordScore + bulletPointScore + dateStructureScore + repeatedSentencesScore + repeatedActionVerbsScore + repeatedPhrasesScore;


  return {
    overallScore: Math.min(totalScore, maxOverAllScore),
    wordScore,
    bulletPointScore,
    dateStructureScore,
    repeatedSentencesScore,
    repeatedActionVerbsScore,
    repeatedPhrasesScore
  };

}
